import { NumberInput } from 'react-admin';

export default NumberInput;
